(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingrediants"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function() {
    // Add click event listener to show popup
    $('.ingredient-view').click(function() {
      $(this).parents('.ingredients-item-wrapper').find('.hidden-popup-wrapper').addClass('active');
    });

    // Add click event listener to hide popup
    $('.ingredient-close').click(function() {
      $(this).closest('.hidden-popup-wrapper').removeClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
